<script setup>
import Button from "@/components/base/Button.vue";

const props = defineProps({
  success: Boolean,
  open: Boolean,
})

const emit = defineEmits(['close'])
</script>

<template>
  <div class="response-modal align-center justify-center" :class="open ? 'open' : ''">
    <div class="response-modal__body relative flex flex-col align-center">
      <svg class="close-btn absolute" @click="emit('close')" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path d="M6 18L18 6M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <h4>{{ success ? "Success!" : "Error!" }}</h4>
      <svg class="image" v-if="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 79" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M40 0C18.1838 0 0.5 17.6838 0.5 39.5C0.5 61.3162 18.1838 79 40 79C61.8162 79 79.5 61.3162 79.5 39.5C79.5 17.6838 61.8162 0 40 0ZM29.3654 24.3077C27.1777 24.3077 26.0109 26.0052 25.5734 26.8762C25.0536 27.9719 24.7917 29.172 24.8077 30.3846C24.8077 31.5919 25.0467 32.8356 25.5734 33.893C26.0109 34.764 27.1736 36.4615 29.3654 36.4615C31.5531 36.4615 32.7198 34.764 33.1574 33.893C33.6841 32.8397 33.9231 31.5919 33.9231 30.3846C33.9231 29.1773 33.6841 27.9336 33.1574 26.8762C32.7198 26.0052 31.5571 24.3077 29.3654 24.3077ZM46.8426 26.8762C47.2802 26.0052 48.4429 24.3077 50.6346 24.3077C52.8223 24.3077 53.9891 26.0052 54.4266 26.8762C54.9533 27.9295 55.1923 29.1773 55.1923 30.3846C55.1923 31.5919 54.9533 32.8356 54.4266 33.893C53.9891 34.764 52.8264 36.4615 50.6346 36.4615C48.4469 36.4615 47.2802 34.764 46.8426 33.893C46.3228 32.7974 46.0609 31.5972 46.0769 30.3846C46.0769 29.1773 46.3159 27.9336 46.8426 26.8762ZM55.0384 54.5384C55.3369 54.2602 55.5763 53.9247 55.7424 53.552C55.9085 53.1793 55.9978 52.777 56.005 52.369C56.0122 51.961 55.9371 51.5558 55.7843 51.1774C55.6315 50.7991 55.404 50.4554 55.1155 50.1669C54.827 49.8783 54.4833 49.6509 54.1049 49.4981C53.7266 49.3452 53.3213 49.2702 52.9134 49.2774C52.5054 49.2846 52.103 49.3739 51.7303 49.54C51.3576 49.706 51.0222 49.9455 50.744 50.244C49.3332 51.6552 47.6582 52.7746 45.8148 53.5383C43.9713 54.302 41.9954 54.6951 40 54.6951C38.0046 54.6951 36.0287 54.302 34.1852 53.5383C32.3418 52.7746 30.6668 51.6552 29.256 50.244C28.68 49.7073 27.9182 49.4151 27.131 49.429C26.3438 49.4429 25.5928 49.7618 25.0361 50.3185C24.4794 50.8751 24.1605 51.6262 24.1466 52.4134C24.1327 53.2005 24.4249 53.9624 24.9616 54.5384C28.9503 58.5263 34.3597 60.7667 40 60.7667C45.6403 60.7667 51.0497 58.5263 55.0384 54.5384Z" fill="url(#paint0_linear_6017_1834)"/>
        <defs>
          <linearGradient id="paint0_linear_6017_1834" x1="0.5" y1="39.5" x2="79.5" y2="39.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#306BFF"/>
            <stop offset="1" stop-color="#9EA4FD"/>
          </linearGradient>
        </defs>
      </svg>
      <svg class="image" v-if="!success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 79" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M40 0C18.1838 0 0.5 17.6838 0.5 39.5C0.5 61.3162 18.1838 79 40 79C61.8162 79 79.5 61.3162 79.5 39.5C79.5 17.6838 61.8162 0 40 0ZM29.3654 24.3077C27.1777 24.3077 26.0109 26.0052 25.5734 26.8762C25.0536 27.9719 24.7917 29.172 24.8077 30.3846C24.8077 31.5919 25.0467 32.8356 25.5734 33.893C26.0109 34.764 27.1736 36.4615 29.3654 36.4615C31.5531 36.4615 32.7198 34.764 33.1574 33.893C33.6841 32.8397 33.9231 31.5919 33.9231 30.3846C33.9231 29.1773 33.6841 27.9336 33.1574 26.8762C32.7198 26.0052 31.5571 24.3077 29.3654 24.3077ZM46.8426 26.8762C47.2802 26.0052 48.4429 24.3077 50.6346 24.3077C52.8223 24.3077 53.9891 26.0052 54.4266 26.8762C54.9533 27.9295 55.1923 29.1773 55.1923 30.3846C55.1923 31.5919 54.9533 32.8356 54.4266 33.893C53.9891 34.764 52.8264 36.4615 50.6346 36.4615C48.4469 36.4615 47.2802 34.764 46.8426 33.893C46.3228 32.7974 46.0609 31.5972 46.0769 30.3846C46.0769 29.1773 46.3159 27.9336 46.8426 26.8762ZM29.26 59.1406C28.6873 59.6944 27.9199 60.001 27.1232 59.9945C26.3265 59.9879 25.5643 59.6687 25.0006 59.1056C24.437 58.5425 24.1171 57.7806 24.1098 56.9839C24.1025 56.1872 24.4084 55.4196 24.9616 54.8463C26.9432 52.8599 29.2991 51.2864 31.893 50.2169C34.4869 49.1473 37.2672 48.603 40.0729 48.6154C45.691 48.6281 51.0746 50.8689 55.0424 54.8463C55.3325 55.1267 55.5638 55.4621 55.7229 55.8329C55.8819 56.2036 55.9656 56.6024 55.9689 57.0058C55.9722 57.4093 55.8951 57.8093 55.7422 58.1827C55.5892 58.556 55.3634 58.8952 55.078 59.1803C54.7926 59.4655 54.4532 59.6909 54.0798 59.8435C53.7063 59.9961 53.3061 60.0728 52.9027 60.0691C52.4992 60.0654 52.1006 59.9814 51.7299 59.822C51.3593 59.6626 51.0242 59.4309 50.744 59.1406C47.9107 56.2993 44.0652 54.6993 40.0527 54.6923C38.0488 54.6824 36.0629 55.0705 34.2103 55.8341C32.3576 56.5977 30.675 57.7216 29.26 59.1406Z" fill="url(#paint0_linear_6017_2001)"/>
        <defs>
          <linearGradient id="paint0_linear_6017_2001" x1="0.5" y1="39.5" x2="79.5" y2="39.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="#306BFF"/>
            <stop offset="1" stop-color="#9EA4FD"/>
          </linearGradient>
        </defs>
      </svg>
      <p v-if="success" class="text-ms">Your application has been accepted. <br/>You will be contacted shortly for further details.</p>
      <p v-if="!success" class="text-ms">Something went wrong. <br/>Please try again!</p>
      <Button @click="emit('close')">Continue</Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.response-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(8, 8, 8, 0.70);
  backdrop-filter: blur(15.800000190734863px);
  display: none;
  z-index: 100;
  &.open {
    display: flex;
  }
  &__body {
    border-radius: clamp(29px, 2.014vw, 145px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: #000;
    width: clamp(465px, 32.292vw, 2500px);
    height: clamp(569px, 39.583vw, 3000px);
    gap: clamp(41px, 2.847vw, 205px);
    padding: 10% clamp(20px, 1.3vw, 100px) 2%;
    h4 {
      color: #F5F6FF;
      font-size: clamp(40px, 2.778vw, 200px);
      font-weight: 400;
      line-height: 85%;
      letter-spacing: -0.4px;
    }
    p {
      line-height: 155.556%;
      letter-spacing: 0.32px;
      text-align: center;
      width: 80%;
      color: rgba(245, 246, 255, 0.60)
    }
  }
  .close-btn {
    width: clamp(24px, 1.667vw, 120px);
    height: clamp(24px, 1.667vw, 120px);
    cursor: pointer;
    transition: opacity .3s ease;
    top: clamp(50px, 3.472vw, 250px);
    right: clamp(57px, 3.958vw, 285px);
    &:hover {
      opacity: 0.7;
    }
  }
  .image {
    width: clamp(80px, 5.556vw, 400px);
    height: clamp(80px, 5.556vw, 400px);
  }
}

@media (max-width: 768px) {
  .response-modal {
    &__body {
      padding: 88px 20px 49px;
      width: 100%;
      max-width: calc(100vw - 48px);
      height: 535px;
      h4 {
        font-size: 35px;
        line-height: 34px;
      }
    }
  }
}
</style>